import { useEffect } from 'react';
import { recordMilestone } from '../api';

export function useTabVisibilityMilestones(
  reportId: number | null,
  publicToken?: string,
): void {
  useEffect(() => {
    if (!reportId) return;

    const handleVisibilityChange = () => {
      const milestone =
        document.visibilityState === 'hidden' ? 'tab_hidden' : 'tab_visible';
      recordMilestone(reportId, milestone, undefined, {
        keepalive: true,
        publicToken,
      }).catch(() => {});
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // report initial visibility state
    handleVisibilityChange();

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [reportId, publicToken]);
}
